
import MHeader from '../Header/Header.vue';
import {
getFinalNumber, // 中奖者信息
getRobLogs, // 参与者列表
getRank, // 参与者前三名
getRobInfo, // 商品详情信息
createNumbers, // 支付订单生成
getDefAddr, // 默认收货地址
wxConfigAjax

} from '../../api';
import XImg from 'vux/src/components/x-img/index.vue'
import dateFormat from 'vux/src/tools/date/format.js'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import querystring from 'vux/src/tools/querystring/index.js'

export default {
components: {
MHeader,
XImg,
Popup,
XDialog
},
directives: {
TransferDom
},
methods: {
progress(res) {
var toal = res.buy_number;
var now = res.sold_number;
return parseInt((now / toal).toFixed(2) * 100) + '%';
},
toDetail(id) {
window.location.href = `http://www.kmjiu.com/public/index.php/wap/itempic.html?item_id=${id}`;
},
toAddress() {
this.$router.push({
name: 'shippingAddress'
});
this.show = false;
},
back() {
this.data = [];
if (this.fromName) {
this.$router.push({
name: 'takeWine',
params: {
title: '一元夺酒'
}
});
} else {
this.$router.push({
path: '/home'
})
}

},
createNumbers() {
this.$store.commit('showIsLoading');
var test = querystring.stringify({
addr_id: this.addr_id,
payed: this.num,
rob_id: this.$route.params.id,
pay_app_id: "wxpayjsapi"
});
createNumbers(test).then(res => {
if (res.data.error_code) {
alert(res.data.msg);
console.error(res);
return;
};
var str = res.data;
str = str.substr(str.indexOf('getBrandWCPayRequest'));
str = str.substring(str.indexOf('{'), str.indexOf('}') + 1);
str = JSON.parse(str);
var item = str;
var that = this;
this.$wechat.chooseWXPay({
timestamp: item.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
nonceStr: item.nonceStr, // 支付签名随机串，不长于 32 位
package: item.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
signType: item.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
paySign: item.paySign, // 支付签名
appId: item.appId,
success: function(res) {
that.$store.commit('updateToast', {
show: true,
text: '付款成功'
});
that.getDate();
that.show = false;
}
});
console.log(res.data);
});
},
rem(num) {
if (this.num == 1) return;
this.num--;
},
getDate(rob_id) {
let test = `rob_id=${rob_id?rob_id:this.$route.params.id}`;
this.data = [];
this.$store.commit('showIsLoading');


this.$http.all([getRobInfo(test), getFinalNumber(test), getRank(test), getRobLogs(test), getDefAddr()]).then(res => {
res.forEach(function(element) {

if (element.data.error_code) {

};
this.data = (this.data).concat(element.data);
}, this);
if (this.data[2].data) {
if (this.data[2].data.length < 3) {
for (let i = this.data[2].data.length; i < 3; i++) {
this.data[2].data.push("");
}
}
} else {
this.data[2].data = [1, 1, 1];
};

if (this.data[0].data.status == 'ENDING') {
this.addr_id = "";
} else {
if (!this.data[4].addrDef) {
const _this = this 
this.$vux.confirm.show({

title: '提示',
content: '您还没有填写收获地址，请先添加收货地址。',
onCancel() {
_this.$router.go(-1);
},
onConfirm() {
_this.$router.push({
path: '/AddAddress/add'
});
}
});
} else {
this.addr_id = this.data[4].addrDef.addr_id
}
}
this.data[3].data.sort((a, b) => b.created_time - a.created_time)
console.log();
wxConfigAjax({
title: `【快买酒】` + this.data[0].data.title,
desc: '【快买酒】 一元夺酒',
url: 'home/takeWineDetail/' + this.$route.params.id,
imgUrl: this.data[0].data.image_default_id
});
});

}
},
data() {
return {
data: [],
show: false,
num: "1",
addr_id: "",
fromName: ""
}
},
created() {

},
filters: {
timer(res) {
return dateFormat(new Date(res * 1000), 'YYYY-MM-DD HH:mm:ss');
},
name(res) {
return res && res.name
},
headimgurl(res) {
return res && res.headimgurl
}
},
beforeRouteEnter: (to, from, next) => {
let fromName = from.name;
if (from.name == 'shippingAddress') {
next(vm => {
vm.show = true;
})
} else {
next(vm => {
vm.getDate();
vm.fromName = fromName;
})
};
},
computed: {
address() {
return this.$store.state.addressDate;
},
addressList() {
return this.$store.state.addressList;
}
},
watch: {
address(newVal, old) {
this.data[4].addrDef = newVal;
this.addr_id = newVal.addr_id;
},
show(val) {
console.log(val);
console.log(JSON.stringify(this.addressList));
if (val && this.addressList == "0") {
this.data[4] = {};
const _this = this 
this.$vux.confirm.show({

title: '提示',
content: '您还没有填写收获地址，请先添加收货地址。',
onCancel() {
_this.$router.go(-1);
},
onConfirm() {
_this.$router.push({
path: '/AddAddress/add'
});
}
});
}

}
}
};



// WEBPACK FOOTER //
// ./src/components/TakeWineDetail/TakeWineDetail.vue